import { render } from "./EmployeePendingLiquidations.vue?vue&type=template&id=35df9b94"
import script from "./EmployeePendingLiquidations.vue?vue&type=script&lang=js"
export * from "./EmployeePendingLiquidations.vue?vue&type=script&lang=js"

import "./EmployeePendingLiquidations.vue?vue&type=style&index=0&id=35df9b94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__